<template>
  <div>
    <create-content-layout :title="'ایجاد محتوای جدید'" :submitFunction="CreateContent"></create-content-layout>
  </div>
</template>
<script>
import CreateContentLayout from "./CreateLayoutContent.vue";
import {mapActions} from 'vuex';

export default {
  name: "CreateContent",
  components: {CreateContentLayout},
  methods: {
    ...mapActions({
      CreateContent: "Content/createContent"
    })
  }
}
</script>